import axios from 'axios';
import axiosClient from './axios-client';
import cookie from 'js-cookie';
const url = '/products/locale';

let cancelToken: any = undefined;

const productsApi = {
  getListProducts(params: any, locale = 'en-SG') {
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('cancelToken');
    }
    cancelToken = axios.CancelToken.source();
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url,
      params: {
        params: JSON.stringify({...params, currencyCode, locale}),
      },
      cancelToken: cancelToken.token,
    });
  },
  getListProductsForId(params: any, locale = 'en-SG') {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url,
      params: {
        id: params,
        currencyCode,
        locale,
      },
    });
  },
  getListProductsForSKU(params: any, locale = 'en-SG', currency?: any) {
    const currencyCode = currency || cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url,
      params: {
        ...params,
        currencyCode,
        locale,
      },
    });
  },
  getListProductsForSKUSale(params: any, locale = 'en-SG') {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url,
      params: {
        ...params,
        currencyCode,
        on_sale: true,
        locale,
      },
    });
  },
  getProductItem(id = 'en-SG', name?: string, locale = 'en-SG') {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url: '/products/product-detail',
      params:
        (id && {
          id,
          currencyCode,
          locale,
        }) ||
        (name && {
          name,
          currencyCode,
          locale,
        }) ||
        {},
    });
  },
  getBrands() {
    return axiosClient({
      method: 'GET',
      url: '/brands',
    });
  },
  getBrandsMerchandise() {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url: `/brands/merchandise?currencyCode=${currencyCode}`,
    });
  },
  getListIdRecentlyViewed() {
    return axiosClient({
      method: 'GET',
      url: '/products/locale/recently-viewed',
    });
  },
  updateListIdRecentlyViewed(data: any, token: string) {
    return axiosClient({
      method: 'PUT',
      url: '/products/locale/recently-viewed',
      data,
      headers: {
        'x-access-token': token ?? '',
      },
    });
  },
  getListProductsLatest(params: any, locale = 'en-SG') {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url,
      params: {
        params: JSON.stringify({...params, currencyCode, locale}),
      },
    });
  },
  getListProductsFeature(params: any, locale = 'en-SG') {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url,
      params: {
        params: JSON.stringify({...params, currencyCode, locale}),
      },
      timeout: 90000,
    });
  },
  getListProductsDealEvent() {
    return axiosClient({
      method: 'GET',
      url: url + '/deals-events',
    });
  },
  getListProductsDealEventDetail(params: any, locale = 'en-SG') {
    if (typeof cancelToken !== typeof undefined) {
      cancelToken.cancel('cancelToken');
    }
    cancelToken = axios.CancelToken.source();
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url: '/products/locale/deals-events/detail',
      params: {
        params: JSON.stringify({...params, currencyCode, locale}),
      },
      cancelToken: cancelToken.token,
    });
  },
  getListProductsDealEventTab(params: any, locale = 'en-SG') {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url: url + `/deals-events/type?id=${params}&locale=${locale}&currencyCode=${currencyCode}`,
    });
  },
  getListProductsNewArrivals(type: any[], locale = 'en-SG', limit:number=20) {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    const params={
      params: JSON.stringify({type: [type?.toString()],"sort":"FEATURED", currencyCode, locale,filter:{},limit}),
    } 
    // console.log('params',params) 
    return axiosClient({
      method: 'GET',
      url: url,
      params:params,
    });
  },
  getListProductsPreOrder() {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url: `/products/pre-order?currencyCode=${currencyCode}`,
    });
  },
  getListProductsSameGenre(id: any, locale = 'en-SG') {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url: '/products/same-genres',
      params: {
        id,
        currencyCode,
        locale,
      },
    });
  },
  searchProductByTitle(title: string, locale = 'en-SG') {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url: url + `/search/title?keyword=${title}&currencyCode=${currencyCode}&locale=${locale}`,
    });
  },
  searchProductByKeyWord(title: string, locale = 'en-SG') {
    const currencyCode = cookie.get('currentToken') || 'SGD';
    return axiosClient({
      method: 'GET',
      url: url + `/search?keyword=${title}&currencyCode=${currencyCode}&locale=${locale}`,
    });
  },
};

export default productsApi;
